const headers = {
  name: "Sales Boq",
  navigate: {
    path: [
      {
        name: "Boqs",
        path: "/app/sales/boqs",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
